export const CONTENT_BASE = 'content/CONTENT_BASE';
export const CONTENT_LOADING = 'content/CONTENT_LOADING';
export const CONTENT_SUCCESS = 'content/CONTENT_SUCCESS';
export const SET_HERO = 'content/SET_HERO';
